<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
/**
 * Contacts-Profile component
 */
export default {
  // PAGE DETAIKS
  page: {
    title: `Visit Profile`,
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      
      title: "VISIT PROFILE FOR",
      items: [
        {
          text: "Active Clients",
          href: "/",
        },
        {
          text: "Visit profile",
          active: true,
        },
      ],

      referral_data: {
        visit_id: this.$route.params.visit,
        to: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        investigations:""
      },     
      
      // DATA
      visit_id: this.$route.params.visit,
      // ADD SERVICE
      service_add: {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: "",
        patient_service: "",
        quantity: "1",
        service: "",
        service_cost: "",
        minimum_price: 0,
        visit_id: this.$route.params.visit,
      },
      prescription: {
        drug_id: "",
        quantity: "1",
        rec_dosage: "",
        patientId: "",
        notDoctor: "",
        is_insured: "0",
        visit_id: this.$route.params.visit,
      },
      model_id: "",
      InsError: "",
      drugError: "",
      mdcnError: "",
      qtyError: "",
      priceError: "",
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("visits", [
      "profileStatus",
      "visit_profile",
      "AllOrderedServices",
      "OrderServiceStatus",
    ]),
    ...mapGetters("insurance", ["PaymentType", "InsurancePackageServices"]),
    ...mapGetters("prescriptions", ["VisitPrescription", "prescriptionStatus"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("inpatient", ["SaveStatus","DischargeStatuses","DischargePrintId","ReferHealthUnitsData"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "antenatalServices",
      "otherServices",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("pharmacy", ["PharmacyItems"]),

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      return this.InsurancePackageServices.filter((serv) => {
        return (
          serv.serviceType == this.service_add.department &&
          serv.package_id == this.visit_profile.insurepackage.id
        );
      });
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevicesx: function () {
      if (this.service_add.department == 1) {
        return this.consultationServices;
      } else if (this.service_add.department == 2) {
        return this.radiologyServices;
      } else if (this.service_add.department == 3) {
        return this.procedureServices;
      } else if (this.service_add.department == 4) {
        return this.labServices;
      } else if (this.service_add.department == 6) {
        return this.dentalServices;
      } else if (this.service_add.department == 7) {
        return this.antenatalServices;
      }else if (this.service_add.department == 8) {
          return this.otherServices;
      } else {
        return [];
      }
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    // GET SERVICE PRICE
    SevicesPrice: function () {
      if (this.service_add.department != "") {
        return this.InsurancePackageServices.filter((ser) => {
          return (
            ser.serviceId == this.service_add.service &&
            ser.package_id == this.visit_profile.insurepackage.id
          );
        });
      } else {
        return "0";
      }
    },

    // END GET SERVER
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.service_add.department = "";
        this.service_add.service = "";
        this.service_add.quantity = "1";
        this.service_add.service_cost = "";
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    }        
  },
  methods: {
    ...mapActions({
      FetchVisitProfile: "visits/fetchVisitProfile",
      FetchClinicStaff: "staffModule/fetchClinicStaff",
      FetchDischargeStatus: "inpatient/fetchDischargeStatus",
      Add_Service: "visits/AddService",
      FetchAllOrderedServices: "visits/fetchAllOrderedServices",
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      AddPrescriptions: "prescriptions/addPrescriptions",
      FetchVisitPrescriptions: "prescriptions/fetchVisitPrescriptions",
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchOtherServices: "services/fetchOtherServices",
      // SERVICES
      FetchInsuranceServices: "insurance/fetchInsPackageServices",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR
   
    checkStaus() {
      if (
        this.service_add.insurance_status == "1" &&
        this.visit_profile.insurepackage == null
      ) {
        this.InsError = "This patient can only take services on a personal bill";
      } else {
        this.InsError = "";
      }
    },

    SetpayType() {
      if (this.visit_profile.is_insured == "insurance") {
        this.service_add.insurance_status = "1";
        this.prescription.is_insured = "1";
        this.service_add.insurance_company = this.visit_profile.inscompany.company_id;
      } else {
        this.service_add.insurance_status = "0";
        this.prescription.is_insured = "0";
        this.service_add.insurance_company = "";
      }
    },
    // ADD SERVICE
    addService(modelId) {
      if (
        this.service_add.insurance_status == "1" &&
        this.visit_profile.insurepackage == null
      ) {
        this.InsError = "This patient can only take services on a personal bill";
        return;
      } else {
        this.InsError = "";
      }
      // if (this.service_add.service_cost < this.service_add.minimum_price) {
      //   this.priceError = "Service price less than "+this.service_add.minimum_price+" is not accepted";
      //   return;
      // } else {
      //   this.priceError = "";
      // }

      this.model_id = modelId;
      this.Add_Service(this.service_add);
    },
    // END ADD SERVICE
    //PRESCRIBE
    Prescribing(modelId) {
      if (this.prescription.drug_id == "") {
        this.drugError = "Drug field is required";
        return;
      } else {
        this.drugError = "";
      }
      if (this.prescription.rec_dosage == "") {
        this.mdcnError = "Dosage field is required";
        return;
      } else {
        this.mdcnError = "";
      }
      if (this.prescription.quantity == "" || this.prescription.quantity < 0.1) {
        this.qtyError = "Quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.prescription.is_insured == "") {
        this.InsError = "Payment Type";
        return;
      } else {
        this.InsError = "";
      }
      this.model_id = modelId;
      this.AddPrescriptions(this.prescription);
    },

    // SET SERVICE PRICE
    getPrice() {
      this.service_add.service_cost = this.SevicesPrice[0].servicePrice.replace(/,/g, '');
    },
    // END SET SERVICE PRICE
    getCost() {
      if (this.service_add.department == 1) {
        let cos_serveice = this.consultationServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = cos_serveice[0].servicePrice.replace(/,/g, '')
        this.service_add.minimum_price = cos_serveice[0].servicePrice.replace(/,/g, '')
      } else if (this.service_add.department == 2) {
        let rad_serveice = this.radiologyServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = rad_serveice[0].servicePrice.replace(/,/g, '');
        this.service_add.minimum_price = rad_serveice[0].servicePrice.replace(/,/g, '');
      } else if (this.service_add.department == 3) {
        let proc_services = this.procedureServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = proc_services[0].servicePrice.replace(/,/g, '');
        this.service_add.minimum_price = proc_services[0].servicePrice.replace(/,/g, '');
      } else if (this.service_add.department == 4) {
        let lab_services = this.labServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = lab_services[0].servicePrice.replace(/,/g, '');
        this.service_add.minimum_price = lab_services[0].servicePrice.replace(/,/g, '');
      } else if (this.service_add.department == 6) {
        let dental_services = this.dentalServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = dental_services[0].servicePrice.replace(/,/g, '');
        this.service_add.service_cost = dental_services[0].servicePrice.replace(/,/g, '');
      } else if (this.service_add.department == 7) {
        let ante_services = this.antenatalServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = ante_services[0].servicePrice.replace(/,/g, '');
        this.service_add.minimum_price = ante_services[0].servicePrice.replace(/,/g, '');
      }else if (this.service_add.department == 8) {
        let oth_services = this.otherServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
        this.service_add.service_cost = oth_services[0].servicePrice.replace(/,/g, '');
        this.service_add.minimum_price = oth_services[0].servicePrice.replace(/,/g, '');
      } else {
        return "0";
      }
    },

    // CLEAR SERVICES INPUTS
    clear_inputs() {
      this.service_add.service_cost = "";
    },
    resetErrors() {
      this.qtyError = "";
      this.drugError = "";
      this.mdcnError = "";
      this.InsError = "";
    },
    resetInputs() {
      this.prescription.quantity = "1";
      this.prescription.rec_dosage = "";
      this.prescription.drug_id = "";
    },

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },

  updated() {
    this.service_add.patientId = this.visit_profile.patient.id;
    this.prescription.patientId = this.visit_profile.patient.id;
  },

  created() {
    this.FetchVisitProfile(this.$route.params.visit);
    this.FetchAllOrderedServices(this.$route.params.visit);
    this.FetchPharmacyItems();
    this.FetchLabServices();
    this.FetchConsultationServices();
    this.FetchRadiologyServices();
    this.FetchVisitPrescriptions(this.$route.params.visit);
    this.FetchDischargeStatus();
  
    // FETCH SERVICES
    setTimeout(() => {
      this.FetchClinicStaff();
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
      this.FetchOtherServices();
      if(this.visit_profile.insurepackage){
      this.FetchInsuranceServices(this.visit_profile.insurepackage.id);
    }
    }, 5000);

    
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title + ' ' + visit_profile.patient.patientName" :items="items" />
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-success p-3">
                  <h5 class="text-primary">{{ visit_profile.patient.patientCode }}</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                    src="@/assets/images/users/avatar-1.jpg"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                </div>

                <h5 class="font-size-15 text-truncate">
                  {{ visit_profile.patient.patientName }}
                </h5>
              </div>

              <div class="col-sm-8">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-size-15">{{ visit_profile.patient.visits }}</h5>
                      <p class="text-muted mb-0">Visits</p>
                    </div>
                    <div class="col-6">
                      <b-spinner
                        v-if="profileStatus"
                        style="float: right"
                        class="m-2"
                        variant="primary"
                        role="status"
                      ></b-spinner>
                    </div>
                  </div>
                  <div class="mt-4" v-show="visit_profile.patient.id">
                    <router-link
                      v-if="user_permissions ? user_permissions.client_profile : false"
                      class="btn btn-primary btn-sm"
                      :to="{
                        name: 'PatientProfile',
                        params: {
                          patient_id: visit_profile ? visit_profile.patient.id : '',
                        },
                      }"
                    >
                      View Patient Profile <i class="mdi mdi-arrow-right ms-1"></i
                    ></router-link>
                    <button
                      v-else
                      class="btn btn-outline-primary btn-sm"
                      title="You are restricted"
                    >
                      View Patient Profile <i class="fa fa-ban ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">VISIT DETAILS</h4>
            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Full Name :</th>
                    <td>
                      {{
                        visit_profile.patient.patientName
                          ? visit_profile.patient.patientName
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Contact :</th>
                    <td>
                      {{
                        visit_profile.patient.patientContact
                          ? visit_profile.patient.patientContact
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr v-show="visit_profile.insurepackage">
                    <th scope="row">Ins Company:</th>
                    <td>
                      {{
                        visit_profile.insurepackage
                          ? visit_profile.insurepackage.company.name
                          : "---"
                      }}
                    </td>
                  </tr>

                  <tr v-show="visit_profile.insurepackage">
                    <th scope="row">Ins Package :</th>
                    <td>
                      {{
                        visit_profile.insurepackage
                          ? visit_profile.insurepackage.packageName
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr v-show="visit_profile.nextOfKin">
                    <th scope="row">Next Of Kin :</th>
                    <td>
                      {{ visit_profile.nextOfKin }} - {{ visit_profile.nextOfKinPhone }}
                    </td>
                  </tr>
                  <tr v-show="visit_profile.temp">
                    <th scope="row">Temperature:</th>
                    <td>
                      {{ visit_profile.temp ? visit_profile.temp : "---" }} &#x2103;
                    </td>
                  </tr>
                  <tr v-show="visit_profile.weight">
                    <th scope="row">Weight:</th>
                    <td>{{ visit_profile.weight ? visit_profile.weight : "---" }} kg</td>
                  </tr>
                  <tr v-show="visit_profile.pressure">
                    <th scope="row">Blood Pressure:</th>
                    <td>
                      {{ visit_profile.pressure ? visit_profile.pressure : "---" }} mmHg
                    </td>
                  </tr>
                  <tr v-show="visit_profile.pulse">
                    <th scope="row">Pulse:</th>
                    <td>{{ visit_profile.pulse ? visit_profile.pulse : "---" }} b/min</td>
                  </tr>
                  <tr v-show="visit_profile.muac">
                    <th scope="row">MUAC:</th>
                    <td>{{ visit_profile.muac ? visit_profile.muac : "---" }} cm</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">SERVICES AND PRESCRIPTIONS</h4>
            <p class="card-title-desc"></p>
            <b-tabs pills justified content-class="p-3 text-muted">
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">SERVICES</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-12">
                    <button
                      @click="SetpayType()"
                      v-if="user_permissions ? user_permissions.order_service : false"
                      v-b-modal.add_service_model
                      class="btn btn-success btn-sm float-end"
                    >
                      <i class="fa fa-plus-circle"></i> Add Service
                    </button>
                    <button v-else class="btn btn-outline-success btn-sm float-end">
                      <i class="fa fa-ban"></i> Add Service
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                      <tr>
                        <th scope="col">SERVICE</th>
                        <th scope="col">QTY</th>
                        <th scope="col">COST</th>
                        <th scope="col">TIME</th>
                        <th scope="col">STATUS</th>
                        <th scope="col">PAY TYPE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(service, index) in AllOrderedServices
                          ? AllOrderedServices
                          : []"
                        :key="index"
                      >
                        <td>{{ service.service ? service.service : "--" }}</td>
                        <td>{{ service.quantity ? service.quantity : "--" }}</td>
                        <td>{{ service.cost ? service.cost : "--" }}</td>
                        <td>{{ service.date ? service.date : "--" }}</td>
                        <td>
                          {{ service.status == "0" ? "Pending..." : "Done" }}
                        </td>
                        <td>
                          {{ service.insured == "1" ? "Insurance" : "Personal" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cog"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">PRESCRIPTIONS</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-12">
                    <button
                      v-if="user_permissions ? user_permissions.add_prescription : false"
                      v-b-modal.prescription
                      class="btn btn-success btn-sm float-end"
                    >
                      <i class="fa fa-plus-circle"></i> Add Prescription
                    </button>
                    <button
                      v-else
                      class="btn btn-outline-success btn-sm float-end"
                      title="You are restricted"
                    >
                      <i class="fa fa-ban"></i> Add Prescription
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                      <tr>
                        <th scope="col">S/N</th>
                        <th scope="col">DRUG</th>
                        <th scope="col">QUANTITY</th>
                        <th scope="col">COST</th>
                        <th scope="col">PAYMENT TYPE</th>
                        <th scope="col">DOSAGE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(drug, index) in VisitPrescription
                          ? VisitPrescription
                          : []"
                        :key="index"
                      >
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{ drug.item.drug }}</td>
                        <td>{{ drug.itemQty }}</td>
                        <td>{{ drug.itemPrice }}</td>
                        <td>
                          {{ drug.isInsured == 1 ? "Insurance Bill" : "Personal Bill" }}
                        </td>
                        <td>{{ drug.medication ? drug.medication : "----" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <!-- ADD SERVICE MODEL -->
          <div class="col-sm-6 col-md-4 col-xl-3">
            <div class="my-4 text-center">
              <b-modal
                hide-footer
                id="add_service_model"
                :title="
                  'ADD NEW SERVICE TO ' + visit_profile.patient.patientName.toUpperCase()
                "
                title-class="font-18"
              >
                <div class="form-group">
                  <label class="col-form-label" for="password">Payment Type</label>
                  <select
                    class="form-control"
                    v-model="service_add.insurance_status"
                    @change="checkStaus()"
                  >
                    <option
                      v-for="(ty, index) in PaymentType"
                      :key="index"
                      :value="ty.id"
                    >
                      {{ ty.name }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="InsError">
                  <em>{{ InsError }}</em>
                </div>
                <div class="form-group">
                  <label class="col-form-label" for="userName">Service Category </label>
                  <model-list-select
                    :list="departments ? departments : []"
                    v-model="service_add.department"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Category"
                  >
                  </model-list-select>
                </div>

                <div class="form-group" v-if="service_add.insurance_status == '1'">
                  <label class="col-form-label">Service</label>
                  <model-list-select
                    :list="filterSevices ? filterSevices : []"
                    v-model="service_add.service"
                    @input="getPrice()"
                    option-value="serviceId"
                    option-text="serviceName"
                    placeholder="select Service"
                  >
                  </model-list-select>
                </div>

                <div class="form-group" v-else>
                  <label class="col-form-label">Service</label>

                  <model-list-select
                    :list="filterSevicesx ? filterSevicesx : []"
                    v-model="service_add.service"
                    @input="getCost()"
                    option-value="id"
                    option-text="serviceName"
                    placeholder="select Service"
                  >
                  </model-list-select>
                </div>
                <div lass="form-group">
                  <label class="col-form-label" for="quantity"
                  >Quantity</label
                  >

                  <input
                      v-model="service_add.quantity"
                      id="quantity"
                      type="number"
                      name="quantity"
                      class="form-control"
                      placeholder="Quantity"
                  />
                </div>
                <div class="form-group">
                  <label class="col-form-label" for="service_price">Service Price</label>

                  <input
                    v-model="service_add.service_cost"
                    id="service_price"
                    type="number"
                    name="service_price"
                    class="form-control"
                    placeholder="Service price"
                  />
                  <div class="text-danger" v-if="priceError">
                  <em>{{ priceError }}</em>
                </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary float-start"
                    @click="closeMode('add_service_model')"
                  >
                    cancel
                  </button>
                  <button
                    @click="addService('add_service_model')"
                    type="submit"
                    class="btn btn-success"
                  >
                    Submit <i class="fa fa-check"></i>
                  </button>
                  <b-spinner
                    v-if="OrderServiceStatus"
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </div>
              </b-modal>

              <!-- Add prescription modal -->
              <b-modal
                hide-footer
                id="prescription"
                :title="'PRESCRIBE FOR ' + visit_profile.patient.patientName.toUpperCase()"
                title-class="font-18"
                @hidden="resetInputs(), resetErrors()"
              >
                <div class="form-group">
                  <label class="col-form-label" for="password">Payment Type</label>
                  <select class="form-control" v-model="prescription.is_insured">
                    <option
                      v-for="(ty, index) in PaymentType"
                      :key="index"
                      :value="ty.id"
                    >
                      {{ ty.name }}
                    </option>
                  </select>
                  <div class="text-danger" v-if="InsError">
                    <em>{{ InsError }}</em>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label" for="userName">Drug </label>
                  <model-list-select
                    :list="PharmacyItems ? PharmacyItems : []"
                    v-model="prescription.drug_id"
                    option-value="id"
                    option-text="drug_name"
                    placeholder="select Drug"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="drugError">
                  <em>{{ drugError }}</em>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Quantity</label>
                  <input
                    v-model="prescription.quantity"
                    type="number"
                    step="any"
                    name="service_price"
                    class="form-control"
                    placeholder="Quantity"
                    @input="resetErrors()"
                  />
                </div>
                <div class="text-danger" v-if="qtyError">
                  <em>{{ qtyError }}</em>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Dosage</label>
                  <input
                    v-model="prescription.rec_dosage"
                    type="text"
                    name="service_price"
                    class="form-control"
                    placeholder="Enter dosage e.g Tabs PCM 1g TDs x 3/7"
                    @input="resetErrors()"
                  />
                </div>
                <div class="text-danger" v-if="mdcnError">
                  <em>{{ mdcnError }}</em>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary float-start"
                    @click="closeMode('prescription')"
                  >
                    cancel
                  </button>
                  <button
                    @click="Prescribing('prescription')"
                    type="submit"
                    class="btn btn-success"
                  >
                    Submit <i class="fa fa-check"></i>
                  </button>
                  <b-spinner
                    v-if="prescriptionStatus"
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </div>
              </b-modal>
            </div>
          </div>
          <!-- END ADD SERVICE MODEL -->
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
